import { motion, type HTMLMotionProps } from "motion/react";

type Variant = "primary" | "ghost" | "danger";

const VARIANTS: Record<Variant, string> = {
  primary: "bg-stone-900 text-white hover:bg-stone-700",
  ghost: "border border-stone-300 text-stone-700 hover:border-stone-400",
  danger: "bg-rose-600 text-white hover:bg-rose-700",
};

export function Button({
  variant = "primary",
  className = "",
  ...props
}: HTMLMotionProps<"button"> & { variant?: Variant }) {
  return (
    <motion.button
      whileTap={{ scale: 0.96 }}
      transition={{ duration: 0.12 }}
      {...props}
      className={`rounded-full px-5 py-2.5 text-sm font-medium transition disabled:opacity-50 ${VARIANTS[variant]} ${className}`}
    />
  );
}
